import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../assets/img/svg/save.svg';
import Cancel from '../../../assets/img/svg/cancel.svg';
import Delete from '../../../assets/img/svg/delete.svg';
import download from "../../../assets/img/svg/DownloadIcon.svg";
import { Tabs, Tab, AppBar, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import del from '../../../assets/img/svg/Del.svg'
import { useNavigate } from "react-router-dom";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import styles from "../../../assets/jss/customStyle";
import $ from "jquery";
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import image from '../../../assets/img/svg/Image.svg';
import Ship from "../../../assets/img/svg/Ship.svg";
import Close from "@material-ui/icons/Close";
import axios from "axios";
import API from "../../../_helpers/endpointService";
import moment from "moment";
import { getSettingsFormat } from "../../../actions/SettingsAction";
import active from '../../../assets/img/svg/active.svg';
import deactive from '../../../assets/img/svg/deactive.svg';
import InnerImageZoom from "react-inner-image-zoom";
import { formatRelativeWithOptions } from "date-fns/fp";
import ViewActualDate from "../DailyTasks/TrainingStatus/ViewActualDate";
import { shipOwnerRole, yardOwnerRole } from "../../common/commonJson";

class EditPlannedDate extends Component {
    constructor(props) {
        super(props)
        this.inputFile = React.createRef();
        this.state = {
            isMobile: false,
            value: 0,
            isView: false,
            ActualDateError: false,
            DocsError: false,
            fileUrl: "",
            fileName: "",
            DelIndex: 0,
            filename: "",
            index: 0,
            awsname: "",
            IfdeletePost: {
                "PlannedDate": null,
                "ActualDate": null,
                "Month": "",
                "Id": 0,
                "TrainingTitle": "",
                "TrainingId": 0,
                "Modify": localStorage.getItem("UserRoles")
            },
            addData: {
                "PlannedDate": null,
                "ActualDate": null,
                "Month": "",
                "Id": 0,
                "TrainingTitle": "",
                "TrainingId": 0,
                "Comments": "",
                "Modify": ""
            },
            Docs: [],

            ProjectId: 0,
            YardId: 0,
            TrainingDateId: 0,
            YardTraining: false,
            actionData: {},
            UserRole: "",
            DelId: {},
            PlannedDates: [],
            ObjectKey: []
        }
    }

    componentDidMount() {
        (localStorage.getItem("UserRoles") == shipOwnerRole) ? this.setState({ isView: true }) : this.setState({ isView: false })
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.YardId = localStorage.getItem("YardId");
        this.state.TrainingDateId = parseInt(localStorage.getItem("TrainingPlanEditId"));
        this.state.YardTraining = localStorage.getItem("YardTraining") == "true" ? true : false;
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.getedittpydocinfo(this.state.TrainingDateId)
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#TrainingPlan1 .MuiListItemText-primary").removeClass("spanTopBar");
        $("#YTrainingPlan .MuiListItemText-primary").removeClass("fw-bolder");
        $("#TrainingPlan").addClass("d-none");
        $("#TrainingPlan").removeClass("d-block");
        $("#YardTrainingPlan").removeClass("active-color");
        $("#TrainingPlan").removeClass("fw-bolder");
    }

    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebaryarddocument");
        }

    };

    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebaryarddocument");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#TrainingPlan1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#YTrainingPlan .MuiListItemText-primary").addClass("fw-bolder");
        $("#TrainingPlan").removeClass("d-none");
        $("#TrainingPlan").addClass("d-block");
        $("#YardTrainingPlan").addClass("active-color");
        $("#TrainingPlan").addClass("fw-bolder");
    };

    AttachFiles = (e) => {
        this.inputFile.current.click();
    };

    UploadFile = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        let data = [];

        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                FileSize: a.size,
                check: false,
                fdata: a,
            }
            data.push(upload);
            this.state.Docs = data;
            this.setState({})
        })
    };

    OpenPopup = (i) => {
        this.state.delindex = i;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }

    DeleteItem = () => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (this.state.Docs[0]?.ObjectKey) {
            this.state.ObjectKey.push(this.state.Docs[0]?.ObjectKey)
        }
        this.state.Docs = [];
        this.setState({})
        window.$("#deletepopup").modal("hide");
    }

    EditCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/yard/trainingplan")
        window.$("#cancelpopup").modal("hide")
    };

    OpenCancel = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show")
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/yard/trainingplan`)
        }
    }

    getedittpydocinfo = (id) => {
        let apiUrl = API.GET_YARDTRAININGPLAN + id + '/actualdate';
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    // response.data?.PlannedDate?.push({
                    //     "Id": 0,
                    //     "Date": ""
                    // })
                    this.setState({
                        actionData: response.data
                    })
                    if (response?.data?.Attachments?.length > 0) {
                        this.state.Docs = response.data?.Attachments
                    }
                    this.setState({})
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    EditSave = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        if (!this.state.Docs[0]?.ObjectKey && this.state.Docs?.length > 0) {
            let formData = new FormData()
            formData.append("attachments", this.state.Docs[0]?.fdata)
            this.AddAttachments(formData)
        } else {
            let data = {
                "Comments": this.state.actionData?.Comments,
                "ActualDate": this.state.actionData?.ActualDate,
                "Attachments": this.state.Docs?.length > 0 ? this.state.actionData?.Attachments : []
            }
            this.put_data(data, this.state.actionData?.TrainingId, this.state?.actionData?.PlannedActualId);
        }
        if (this.state.ObjectKey?.length > 0) {
            this.delete_attachments(this.state.ObjectKey);
        }
    }

    delete_attachments = (data) => {
        let apiUrl = API.DELETE_ATTACHMENTS;
        axios({
            method: "DELETE",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    }

    AddAttachments = (formData) => {
        let apiUrl = API.POST_ATTACHMENTS + 'TrainingPlan';
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: formData,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    let data = {
                        "Comments": this.state.actionData?.Comments,
                        "ActualDate": this.state.actionData?.ActualDate,
                        "Attachments": response.data
                    }
                    this.put_data(data, this.state.actionData?.TrainingId, this.state?.actionData?.PlannedActualId);
                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {
                }
            });
    }

    put_data = (data, Id, planId) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        let apiUrl = API.GET_YARDTRAININGPLAN + Id + '/actualTraining/' + planId;
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate("/yard/trainingplan");
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    handleInputChange = (e, str) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.actionData[str] = e.target.value;
        this.setState({})
    }

    handleDelete = (ind, id) => {
        window.$("#deletepopupactual").modal("show");
        this.state.DelIndex = ind;
        this.state.DelId = id;
        this.setState({})
    }

    render() {
        let { classes, menuToggle } = this.props;
        const { isView } = this.state;
        return (
            <>
                {isView == true ?
                    <ViewActualDate /> : <>
                        {
                            this.state.isMobile ?
                                <>
                                    <div className="row w-100 mt-4">
                                        <div className="col-6 mt-auto">
                                            <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                                <ListItem onClick={this.sidebar} >
                                                    <ListItemText id={"PLAN" + "1"} className='  textNaviIcon' primary="Yard Documents" />
                                                    <NavigateNextIcon id="PLAN" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                                    <Divider className='border-bottom' />
                                                </ListItem>
                                            </List>
                                        </div>
                                        <div className="col-6 pt-2 mt-5 ">
                                            <h4>{"Edit Training Plan"}</h4>
                                        </div>
                                    </div>
                                </>
                                :
                                <></>
                        }
                        <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                            {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                                <tbody>
                                    <tr>
                                        {!isView ? <></> : <>
                                            <td width="5%" className="border-right">
                                                <i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                            <td></td>
                                            <td></td>
                                            <td></td></>}
                                        {this.state.value == 1 ? <>
                                            <td width="5%" className="border-right">
                                                <i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </> : <>
                                            {isView ? <></> : <>

                                                <td className="border-right text-center">
                                                    <i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                                <td className="border-right text-center">
                                                    <span className={classes.button} disabled={isView ? true : false} onClick={this.EditSave} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px', opacity: isView ? '0.5' : '' }}></img>&nbsp;Save</span> </td>
                                                <td className="border-right text-center">
                                                    <span className={`${classes.button}`} onClick={this.OpenCancel} style={{ minWidth: '70px' }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</span>
                                                </td>
                                                {/* <td className=" text-center">
                                            <span className={`${classes.button}`} disabled={isView ? true : false} style={{ minWidth: '70px' }} onClick={() => { this.OpenActualDelete() }}><img src={Delete} style={{ marginTop: '-4px', opacity: isView ? '0.5' : '' }}></img>&nbsp;Delete</span>
                                        </td> */}
                                            </>}
                                        </>}
                                    </tr>
                                </tbody>
                            </table>
                                : <table className="dataTable" width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="5%" className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.OpenCancel}></i></td>
                                            <td width="95%">
                                                {isView ? <></> : <>
                                                    {this.state.value == 0 ? <>
                                                        <button className={classes.button} disabled={isView ? true : false} onClick={() => this.EditSave()}><img src={Save} style={{ marginTop: '-4px', opacity: isView ? '0.5' : '' }}></img>&nbsp;Save</button>
                                                        <button className={`${classes.button} pl-3`} onClick={this.OpenCancel}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                                        {/* <button className={`${classes.button} pl-3`} disabled={isView ? true : false} onClick={() => { this.OpenActualDelete() }}><img src={Delete} style={{ marginTop: '-4px', opacity: isView ? '0.5' : '' }}></img>&nbsp;Delete</button> */}
                                                    </> : <></>}
                                                </>}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>}
                            <div style={{ margin: this.state.isMobile ? "0" : "5px" }}>
                                {this.state.isMobile ? <></> : <h6 className="col-12 mt-3 ml-2">{"Edit Training Plan"}</h6>}
                                <div className="row">
                                    <div className={this.state.isMobile ? isView ? "row px-0 mt-n3" : "row ml-2 pr-4 mt-3" : isView ? "row pl-5 pt-2 pr-3" : "row pl-5 pt-2 pr-3"}>
                                        <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-top border-left border-right border-bottom"}`}>
                                            <div className={`col-12 col-sm-12  col-lg-3 col-xl-2  ${this.state.isMobile ? " border-top border-left border-right" : "col-md-3 pt-2"}`}>
                                                <label className={this.state.isMobile ? "mt-2" : "float-end text-right"}>Training Title&nbsp;:</label>
                                            </div>
                                            <div className={`col-12 col-sm-12   col-lg-9 col-xl-2   ${this.state.isMobile ? "pb-2 border-left border-right border-bottom col-md-12 pt-1" : "col-md-9 py-3"}`}>
                                                {this.state?.actionData?.TrainingTitle && this.state?.actionData?.TrainingTitle}
                                            </div>
                                        </div>
                                        <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                            <div className={`col-12 col-sm-12  col-lg-3 col-xl-2  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-3"}`}>
                                                <label className={this.state.isMobile ? "d-flex mt-2" : "float-end text-right d-flex"}>Planned Date&nbsp;:
                                                </label>
                                            </div>
                                            <div className={`col-12 col-sm-12   col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : " pb-4 col-md-2 pt-4 mt-2"}`}>
                                                <label>{this.state.actionData?.PlannedDate && moment(this.state.actionData?.PlannedDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</label>
                                            </div>
                                            <div className={`col-12 col-sm-12  col-lg-3 col-xl-2 ${this.state.isMobile ? "border-left border-right col-md-12" : "px-0 col-md-3 mt-2"}`}>
                                                <label className={this.state.isMobile ? "d-flex mt-2" : "float-end d-flex text-right"}>Actual Date&nbsp;:
                                                    {/* {isView ? <></> :
                                                    <div className={`${classes.helperText}`}>
                                                        <div className="MuiFormHelperText-contained">*</div>
                                                    </div>} */}
                                                </label>
                                            </div>
                                            <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "pb-4 col-md-4 pt-4"}`}>
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    type="date"
                                                    fullWidth
                                                    id="type-date1"
                                                    value={this.state.actionData?.ActualDate && moment(this.state.actionData?.ActualDate).format("yyyy-MM-DD")}
                                                    placeholder={this.state.actionData?.ActualDate && moment(this.state.actionData?.ActualDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleInputChange(e, "ActualDate") }}
                                                    InputProps={{
                                                        className: `border-radius ${classes.inputfieldAlign}`
                                                    }}
                                                    inputProps={{
                                                        min: `${this.state.actionData?.PlannedDate && moment(this.state.actionData.PlannedDate).format("yyyy-MM-DD")}`,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className={`row mx-0 ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                            <div className={`col-12 col-sm-12  col-lg-3 col-xl-2 ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-3"}`}>
                                                <label className={this.state.isMobile ? " mt-2" : "float-end m-0 text-right pt-4"}>Attachments&nbsp;:</label>
                                            </div>
                                            <div className={`col-12 col-sm-12 col-lg-5 col-xl-3  ${this.state.isMobile ? "border-left border-right col-md-12 pt-1 pb-3" : "col-md-5 pt-4 pb-4"}`}>
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    disabled
                                                    onChange={(e) => { this.UploadFile(e) }}
                                                    placeholder="Browse File"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment className="mr-0">
                                                                <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                                    <AttachFileIcon />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                        className: `border-radius ${classes.inputfieldAlign}`
                                                    }} />
                                                <input
                                                    type="file"
                                                    // multiple="multiple"
                                                    hidden
                                                    onChange={(e) => { this.UploadFile(e) }}
                                                    ref={this.inputFile}
                                                />
                                            </div>
                                            <div className={`col-12 col-sm-12  col-md-4 col-lg-4 col-xl-7 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                                <div className={this.state.isMobile ? "row pl-2 pr-3" : "row px-1"}>
                                                    {this.state.Docs && this.state.Docs.map((i, ind) => {
                                                        return (
                                                            <div className={`col-12 col-lg-12 col-xl-12 align-items-center  px-1 mt-1 mb-2 ${window.innerWidth < 360 ? "col-12" : this.state.isMobile ? "col-md-12 col-sm-12" : "col-md-12 col-sm-12"}`}>
                                                                <div className="row d-flex pr-3">
                                                                    <div className="col-10 col-sm-10 col-lg-10 col-xl-10 col-md-10">
                                                                        <div className="pt-2 overflow">{i.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                                    </div>
                                                                    <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 pl-1 pr-2 mt-2 pt-1">
                                                                        <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(i.FileName, i.AwsUniqueFileName, i.Id) }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            this.state.actionData?.TrainingTypeRoles?.length > 0 &&
                                            this.state.actionData?.TrainingTypeRoles?.map((role) => (
                                                <div className={`row mx-0 ${this.state.isMobile ? "" : "border-left border-right border-top border-bottom p-3"}`}>
                                                    <div className={`col-12 col-sm-12  col-lg-3 col-xl-2  ${this.state.isMobile ? "border-top border-left border-right" : "col-md-2"}`}>
                                                        <label className={this.state.isMobile ? "mt-2" : "float-end text-right"}>{role?.Type}&nbsp;:</label>
                                                    </div>
                                                    <div className={`col-12 col-sm-12 col-lg-9 col-xl-10   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10"}`}>
                                                        {role?.Roles?.length > 0 &&
                                                            role?.Roles?.map((r) => (<>
                                                                <label className="pb-2">{r}</label> <br />
                                                            </>))
                                                        }
                                                    </div>
                                                </div>
                                            ))
                                        }
                                        <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                            <div className={`col-12 col-sm-12  col-lg-3 col-xl-2  ${this.state.isMobile ? "border-left border-right" : "mt-n4 col-md-3"}`}>
                                                <label className={this.state.isMobile ? "mt-2" : "float-end text-right"}>Comments&nbsp;:</label>
                                            </div>
                                            <div className={`col-12 col-sm-12   col-lg-9 col-xl-10   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-9 pt-4"}`}>
                                                <TextField
                                                    multiline
                                                    rows={8}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    disabled={isView ? true : false}
                                                    value={this.state.actionData?.Comments}
                                                    onChange={(e) => { this.handleInputChange(e, "Comments") }}
                                                    InputProps={{
                                                        className: `border-radius ${classes.inputfieldAlign} ${isView ? "view-color" : ""} `
                                                    }}
                                                />
                                                <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.actionData?.Comments?.length == undefined ? 1000 - 0 : 1000 - this.state.actionData?.Comments?.length}/1000 Characters left</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div >
                            <div class="modal fade " id="viewscreen" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: this.state.isMobile ? "25%" : "13%", left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "", overflowY: 'scroll', height: "90vh" }}>
                                <div class="modal-dialog modal-lg " role="document">
                                    <div class="modal-content ">
                                        <div class="modal-body pt-0 pb-2 pr-0 pl-0 ">
                                            <div className="row">
                                                <div className="col-12 ">
                                                    <div className='cursorPointer float-end mr-3' id="viewscreen" onClick={() => {
                                                        window.$('#viewscreen').modal('hide')

                                                    }} >
                                                        <button className={`${classes.button} px-0 hidefield`} >&nbsp;Close</button>
                                                    </div>
                                                </div>
                                                <div className='col-12 text-center'>
                                                    <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel" style={{}} >
                                                        <div class="carousel-indicators">

                                                        </div>
                                                        <div class="carousel-inner" >
                                                            {this.state.Docs && this.state.Docs.map((i, ind) => (<>
                                                                <div class={ind === this.state.index ? "carousel-item active col-12 text-center align-middle" : " align-middle carousel-item col-12 text-center"}>
                                                                    <div>
                                                                        <InnerImageZoom
                                                                            moveType="drag"
                                                                            zoomScale={2}
                                                                            hideCloseButton={true}
                                                                            src={i.FileUrl}
                                                                            hasSpacer={true}
                                                                            afterZoomIn={() => { $('#viewscreen > div > div ').addClass('Transparent'); $('.hidefield').removeClass('d-block'); $('.hidefield').addClass('d-none'); }}
                                                                            afterZoomOut={() => { $('#viewscreen > div > div ').removeClass('Transparent'); $('.hidefield').addClass('d-block'); $('.hidefield').removeClass('d-none'); }}
                                                                        />
                                                                    </div>
                                                                    {this.state.Docs.length <= 1 ? "" : <>
                                                                        <button class="carousel-control-prev my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.preView(ind - 1)} data-bs-slide="prev">
                                                                            <span class="carousel-control-prev-icon black" aria-hidden="true"></span>
                                                                            <span class="visually-hidden">Previous</span>
                                                                        </button>
                                                                        <button class="carousel-control-next  my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.nextView(ind + 1)} data-bs-slide="next">
                                                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                                            <span class="visually-hidden">Next</span>
                                                                        </button>
                                                                    </>}
                                                                </div>
                                                            </>))}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                                <div class="modal-dialog" role="document">
                                    <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                        <div class="modal-body pb-0">
                                            <h1 className="text-center">
                                                <img src={del}></img>
                                            </h1>
                                            <div className="text-center">
                                                <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                        </div>
                                        <div class="modal-footer border-top-0 m-auto">
                                            <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.EditCancel}><span className="" >Yes</span></button>
                                            <button type="button" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => { window.$("#cancelpopup").modal("hide") }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                                <div class="modal-dialog" role="document">
                                    <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                        <div class="modal-body pb-0">
                                            <h1 className="text-center">
                                                <img src={del}></img>
                                            </h1>
                                            <div className="text-center">
                                                <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                        </div>
                                        <div class="modal-footer border-top-0 m-auto">
                                            <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                            <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                                <div class="modal-dialog" role="document">
                                    <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                        <div class="modal-body pb-0">
                                            <h1 className="text-center">
                                                <img src={del}></img>
                                            </h1>
                                            <div className="text-center">
                                                <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                        </div>
                                        <div class="modal-footer border-top-0 m-auto">
                                            <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                            <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> </>}
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
        historyLog: state.commonReducer.historyLog || [],
    };
}

EditPlannedDate.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditPlannedDate))
);
